import { render } from "./DynamicContentsList.vue?vue&type=template&id=78808097"
import script from "./DynamicContentsList.vue?vue&type=script&lang=js"
export * from "./DynamicContentsList.vue?vue&type=script&lang=js"

import "./DynamicContentsList.vue?vue&type=style&index=0&id=78808097&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__